module.exports = "/images/restore.svg?7b48ee5ba7ba3e214153e7c662dc5496";